import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    accessBestCryptoPrices: 'Access the Best Crypto Prices',
    smartTradeDescription:
      'Our Smart Trade system automatically connects you to the top exchanges in real-time, ensuring the best trade execution whenever you buy or sell.',
    investBetterDescription:
      'This is just one of the ways we help you invest better.',
    riskDisclosureWarning:
      'Make sure to have reviewed both our General Risk Disclosures and Crypto Risk Disclosures.',
  },
  de: {
    accessBestCryptoPrices: 'Zugriff auf die besten Krypto-Preise',
    smartTradeDescription:
      'Unser Smart-Trade-System verbindet dich automatisch in Echtzeit mit den Top-Börsen und sorgt dafür, dass du bei jedem Kauf oder Verkauf die besten Preise erhältst.',
    investBetterDescription:
      'Dies ist nur eine der Möglichkeiten, wie wir dir helfen, besser zu investieren.',
    riskDisclosureWarning:
      'Vergewissere dich, dass du sowohl unsere allgemeinen Risikohinweise als auch die Krypto-Risikohinweise gelesen hast.',
  },
});
